import { combineReducers } from 'redux';
import activityBuilderReducers from '../modules/learning/activityBuilder/state/reducers';

const rootReducer = combineReducers({
  ...activityBuilderReducers
});

export default rootReducer;
